const base64UrlEncode = (binary: string): string => btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

const base64UrlEncodeBuffer = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]!);
  }
  return base64UrlEncode(binary);
};

const generateRandomString = (length: number): string => {
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return base64UrlEncodeBuffer(array.buffer);
};

export const generateCodeVerifier = (): string => {
  return generateRandomString(32);
};

export const generateCodeChallenge = async (verifier: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64UrlEncodeBuffer(digest);
};
